import React from 'react';
import { CheckCircle, AlertTriangle, AlertCircle, HelpCircle, type LucideIcon } from 'lucide-react';
import type { ComplianceStatus } from '../../types';
import './ComplianceStatusBadge.css';

export interface ComplianceStatusBadgeProps {
  /** Compliance status */
  status: ComplianceStatus;
  /** Optional custom className */
  className?: string;
}

const STATUS_CONFIG: Record<
  ComplianceStatus,
  { label: string; modifier: string; Icon: LucideIcon }
> = {
  compliant: {
    label: 'Prüfbereit',
    modifier: 'compliant',
    Icon: CheckCircle,
  },
  has_warnings: {
    label: 'Hinweise',
    modifier: 'warnings',
    Icon: AlertTriangle,
  },
  has_issues: {
    label: 'Handlungsbedarf',
    modifier: 'issues',
    Icon: AlertCircle,
  },
  incomplete: {
    label: 'Unvollständig',
    modifier: 'incomplete',
    Icon: HelpCircle,
  },
};

export const ComplianceStatusBadge: React.FC<ComplianceStatusBadgeProps> = ({
  status,
  className = '',
}) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.incomplete;
  const { Icon } = config;

  return (
    <span
      className={`compliance-status-badge compliance-status-badge--${config.modifier} ${className}`.trim()}
    >
      <Icon size={14} />
      <span className="compliance-status-badge__text">{config.label}</span>
    </span>
  );
};

export default ComplianceStatusBadge;
